export default __webpack_public_path__ + "jet.38804de4.png";